<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="magic-boy-synopsis">
<h1>Magic Boy Synopsis</h1>
<p>Ben and Amy Starbright stay with Granny while their parents go away. They find that Granny is strange when her friend flies past their window on a broomstick. Vega Starbright is caring for Herbert Laglolly, turned scarecrow by the witch, Devilla Cragg.</p>
<p>Ben and Amy are bullied at school. Granny helps with a potion to stop the bullying, but it all goes wrong when Ben mixes up the ingredients. Being pinned to the kitchen wall, they realise that Granny gets awfully cross when she wants to.</p>
<p>The bullies finally get punished. Ben’s teacher, Mr Drought, loses his trousers in front of the class, when he picks on Ben to spite Granny. The children have left their city life and are fond of Granny, with her odd ways. She asks them to pick herbs in the forest.</p>
<p>Devilla Cragg uses this to entice Ben and Amy deep into the forest. She tries to kidnap them to spite Vega, but the old witch appears when Snatch warns her of the danger. After a fierce battle, Devilla is left hanging by her red bloomers from a tree branch.</p>
<p>The forest elves and fairies come to Tuckaway Farm for help, because Devilla has poisoned their food. Helped by Ben and Amy, Granny creates a haven, called Pixieville. The children love to watch the bad-tempered elves arguing.</p>
<p>Farmer Bludgeon causes trouble, so Granny scatters a powder over his farm, and he is attacked by his tractor and farm animals. His vegetables uproot themselves and march over to Tuckaway Farm. After a meeting between Bludgeon and Granny, peace is restored between the two neighbours.</p>
<p>Vega Starbright enters the Witches’ Broomstick Race and has a frightening ride. A fire later threatens to engulf Witchington. With Granny organizing them, the witches put it out, but Granny has another great battle with Devilla. Granny is hurt and Ben and Amy nurse her. So, she holds a party they will never forget. But then Granny hears that her wards’ parents are missing.</p><br/>
<p style="text-align: center;"><strong>***</strong></p><br/>
<p style="text-align: center;"><strong>MAGICBOY</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?42b41a7a